import IpsSpinner from './IpsSpinner.vue';

export default IpsSpinner;
